import React from 'react';
import { IRowAnnouncement } from '../../../../types/announcements';
import transliterate from '../../../../helpers/transliterate';
import { useAnnouncement } from '../../../../hooks/useAnnouncement';
import { AnnouncementItem } from './Announcement';
import Styled from './styled';
import Counter from './Counter';
import CurrencyIcon from '../../../../shared/components/Icons/Currency';

export const RowAnnouncement = ({ announcement }: { announcement: IRowAnnouncement }) => {
  const { counter, showCounter, handleCounter, ticketsCountLabel, t } =
    useAnnouncement(announcement);
  const {
    fragment: {
      attributes: { label: row, sector: sectorName },
    },
    price,
    count,
  } = announcement;

  const title = (
    <>
      <span>{transliterate(sectorName)}</span>
      {row && (
        <span>
          {t('row')} {row}
        </span>
      )}
    </>
  );
  const subtitle = (
    <>
      {<Styled.Count>{ticketsCountLabel}</Styled.Count>}
      {<Styled.Note>*{t('announcements_random_seat')}</Styled.Note>}
    </>
  );

  return (
    <AnnouncementItem
      title={title}
      subtitle={subtitle}
      announcementType={announcement.announcement_type}
      ticketType={announcement.ticket_type}
    >
      {counter === null && (
        <Styled.AnnouncementBtn onClick={showCounter}>
          {price} <CurrencyIcon width={10} height={11} fill="#fff" />
        </Styled.AnnouncementBtn>
      )}
      {counter !== null && <Counter value={counter} max={count} setValue={handleCounter} />}
    </AnnouncementItem>
  );
};
